export function addUniquenotEmptyElements(entities) {
    return entities.filter((el, index, arr) => arr.indexOf(el) === index).filter(e => e);
}
//# sourceMappingURL=addUniquenotEmptyElements.js.map